import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import Icon from '~/components/Icon/Icon';
import styles from './CookieBannerV3.module.scss';
import { useCookieBanner } from './useCookieBanner';

/** GDPR cookie banner for the V3 design system. */
const CookieBannerV3 = () => {
  const { t } = useTranslation();
  const { isVisible, setConsent, cookiePolicyLink } = useCookieBanner();

  if (!company.showCookieBanner || !isVisible) {
    return null;
  }

  return (
    <>
      <div className={styles.overlay} />
      <div className={styles.banner} role="dialog" aria-live="polite">
        <button
          type="button"
          className={styles.closeButton}
          onClick={() => setConsent('dismissed')}
          aria-label={t('close')}
        >
          <Icon type="close" />
        </button>
        <div className={styles.content}>
          <div className={styles.title}>{t('phrases:cookieBannerTitle')}</div>
          <div className={styles.description}>
            <Trans
              i18nKey="phrases:cookieBannerDescription"
              components={[
                <Link
                  to={cookiePolicyLink}
                  className="link"
                  key="cookie-link"
                />,
              ]}
            />
          </div>
        </div>
        <div className={styles.actions}>
          <button
            type="button"
            className={styles.primaryButton}
            onClick={() => setConsent('accepted')}
          >
            {t('phrases:cookieBannerAccept')}
          </button>
          <button
            type="button"
            className={styles.secondaryButton}
            onClick={() => setConsent('declined')}
          >
            {t('phrases:cookieBannerDecline')}
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieBannerV3;
